var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 26.993,
    viewBox: "0 0 31.5 26.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-desktop",
    "data-name": "Icon ionic-ios-desktop",
    transform: "translate(-2.25 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    "data-name": "Caminho 790",
    d: "M24.75,31.092a.358.358,0,0,0-.3-.3l-1.568-.134a2.443,2.443,0,0,1-1.568-1.99l-.084-.541H14.766l-.084.534a2.455,2.455,0,0,1-1.568,1.99l-1.568.134a.384.384,0,0,0-.3.3.361.361,0,0,0,.359.408H24.391A.355.355,0,0,0,24.75,31.092Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    "data-name": "Caminho 791",
    d: "M33.251,4.992a1.7,1.7,0,0,0-1.2-.492H3.952a1.686,1.686,0,0,0-1.2.492,1.712,1.712,0,0,0-.506,1.2V25.313a1.7,1.7,0,0,0,.506,1.2A1.666,1.666,0,0,0,3.938,27H32.063a1.654,1.654,0,0,0,1.181-.492,1.712,1.712,0,0,0,.506-1.2V6.188A1.676,1.676,0,0,0,33.251,4.992ZM18,25.313a.563.563,0,1,1,.563-.562A.564.564,0,0,1,18,25.313ZM32.337,22.5H3.67a.282.282,0,0,1-.281-.281V6.469a.846.846,0,0,1,.844-.844H31.774a.846.846,0,0,1,.844.844v15.75A.282.282,0,0,1,32.337,22.5Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktop);
export default __webpack_public_path__ + "static/media/iconDesktop.6dca9c953dc682e512ec1fe6775a85d8.svg";
export { ForwardRef as ReactComponent };